for (const dismiss of document.querySelectorAll('[data-dismiss-target]')) {
    const target = document.querySelector(dismiss.dataset.dismissTarget);
    if (target !== null) {
        dismiss.addEventListener('click', (e) => {
            target.parentElement.removeChild(target);
        });
    }
}
